import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import Modal, {
	ModalBackground,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalHeader, {
	ModalHeaderTitle,
} from 'packages/kakapo-ui-kit/components/modals/ModalHeader';
import PersonAvatar from 'packages/kakapo-ui-kit/components/users/PersonAvatar';
import Button, { ButtonSize } from 'packages/kakapo-ui-kit/components/editors/Button';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';
import Color from 'packages/kakapo-ui-kit/components/common/Color';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

const Row = styled(Flex)`
	padding: 4px 4px;
	margin: 0px -4px;

	&:nth-child(even) {
		background: ${(props) => props.theme.colors.lightBlueLight};
		border-radius: 4px;
	}
`;

const Anchor = styled(Link)`
	color: ${(props) => props.theme.colors.primary};
	text-decoration: none !important;

	&:hover {
		text-decoration: underline !important;

		&:active {
			color: black;
		}
	}
`;

export default function ComplimentCreateSelector() {
	const { t } = useTranslation();

	const history = useHistory();

	const query = graphql.useComplimentTargetsQuery({ variables: {} });

	const users = _.sortBy(
		_.uniqBy(
			query.data?.viewer.roles.flatMap((role) => {
				if (role.targetV2?.__typename === 'Group') {
					return role.targetV2.members.edges.map(({ node }) => node);
				} else if (role.targetV2?.__typename === 'User') {
					return [role.targetV2];
				} else {
					return [];
				}
			}) ?? [],
			(user) => user.id,
		),
		(user) => `${user.firstName} ${user.lastName}`,
	);

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader onCancel={() => history.goBack()}>
					<ModalHeaderTitle>{t('compliments.selector.title')}</ModalHeaderTitle>
				</ModalHeader>
				<ModalContent>
					<Box mb={3}>
						<SectionTitle>{t('compliments.selector.label')}</SectionTitle>
						<Box mt={2}>
							<Paragraph color="slateBlue">
								{t('compliments.selector.description')}{' '}
								<Anchor to="/search?q=">{t('compliments.selector.searchLink')}</Anchor>.
							</Paragraph>
						</Box>
					</Box>
					{query.data ? (
						users.map((user) => (
							<Row key={user.id} alignItems="center">
								<Box flexGrow={0} flexShrink={0}>
									<PersonAvatar person={user} />
								</Box>
								<Box mx={2} flexGrow={1} flexShrink={1}>
									<Color color="slateBlue">
										{user.firstName} {user.lastName}
									</Color>
								</Box>
								<Box flexGrow={0} flexShrink={0}>
									<Button
										size={ButtonSize.Small}
										onClick={() => history.push(`/user/${user.id}/compliments/give`)}
									>
										{t('compliments.selector.action')}
									</Button>
								</Box>
							</Row>
						))
					) : (
						<Spinner isLoading size="18px" />
					)}
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
